<template lang="pug">
el-tag(:type="type") {{ $t(status || "") }}
</template>

<script setup lang="ts">
import { computed } from "vue";
import { statuses } from "../constants";

const props = defineProps<{ status?: string }>();

const type = computed(() => {
  switch (props.status) {
    case statuses.new:
      return "info";
    case statuses.planned:
      return "primary";
    case statuses.completed:
      return "success";
    case statuses.rejected:
      return "danger";
    case statuses.inProcess:
      return "warning";
  }
  return "primary";
});
</script>
